function formDeleteDynamicError({
  values,
  form,
  valueName,
}) {
  function isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
  }

  Object.keys(values).forEach((field) => {
    if (isObject(values[field])) {
      formDeleteDynamicError({
        values: values[field],
        form,
        valueName: valueName ? [...valueName, field] : [field],
      });
      return;
    }
    const error = form.getFieldError(valueName ? [...valueName, field] : field);
    if (error.length === 0) {
      return;
    }

    // Clear error message of field
    form.setFields([
      {
        name: valueName ? [...valueName, field] : field,
        errors: [],
      },
    ]);
  });
}
export default formDeleteDynamicError;
